import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';

export default function FormSkeleton() {
  return (
    <Box sx={{ viewTransitionName: 'steps', width: '100%' }}>
      <Stack gap={2} sx={{ mb: 4 }}>
        <Stack direction="row" alignItems="center" spacing={1} width="100%">
          <Skeleton variant="rounded" width={200} height={20} />
        </Stack>

        <Grid container spacing={3} size={{ xs: 10 }}>
          <Grid size={{ xs: 12 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
          <Grid size={{ xs: 12, lg: 6 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
        </Grid>
        <Grid container spacing={2} size={{ xs: 6 }} sx={{ mt: 2 }}>
          <Grid size={{ xs: 12 }}>
            <Skeleton variant="rounded" width={'100%'} height={35} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Skeleton variant="rounded" width={'100%'} height={35} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Skeleton variant="rounded" width={'100%'} height={35} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Skeleton variant="rounded" width={'100%'} height={35} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Skeleton variant="rounded" width={'100%'} height={35} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Skeleton variant="rounded" width={'100%'} height={35} />
          </Grid>
          <Grid size={{ xs: 12 }} sx={{ pl: 4 }}>
            <Skeleton variant="rounded" width={'100%'} height={20} />
          </Grid>
        </Grid>
      </Stack>

      <Stack gap={2} sx={{ mb: 4 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Skeleton variant="rounded" width={200} height={20} />
        </Stack>
        <Grid container spacing={2} size={{ xs: 10 }}>
          <Grid size={{ xs: 8 }}>
            <Skeleton variant="rounded" width={'100%'} height={30} />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Skeleton variant="rounded" width={'100%'} height={40} />
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
}
